import { createSanityDocument } from "@/lib/sanity";

export const submitComment = async ({
  postId,
  authorName,
  commentText,
}: {
  postId: string;
  authorName: string;
  commentText: string;
}) => {
  try {
    const newComment = {
      _type: "comment",
      post: { _type: "reference", _ref: postId }, // Reference to the post
      authorName,
      commentText,
      timestamp: new Date().toISOString(),
    };

    const result = await createSanityDocument(newComment);
    return result;
  } catch (error) {
    console.error("Error submitting comment:", error);
    throw error;
  }
};
